export default __webpack_public_path__ + "6433140da6ff27a2b81885b5ccb0ca5e.svg";